"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable @typescript-eslint/no-explicit-any */

var react_1 = require("react");

var react_popper_1 = require("react-popper");

var downshift_1 = require("downshift");

var useDropdownMenu = function useDropdownMenu(_ref) {
  var items = _ref.items,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
      _ref$itemToString = _ref.itemToString,
      itemToString = _ref$itemToString === void 0 ? function (item) {
    return item;
  } : _ref$itemToString,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? [0, 10] : _ref$offset,
      _ref$loopItemsOnKeyDo = _ref.loopItemsOnKeyDown,
      loopItemsOnKeyDown = _ref$loopItemsOnKeyDo === void 0 ? true : _ref$loopItemsOnKeyDo,
      _ref$closeMenuOnLastI = _ref.closeMenuOnLastItem,
      closeMenuOnLastItem = _ref$closeMenuOnLastI === void 0 ? false : _ref$closeMenuOnLastI,
      _ref$closeMenuOnFirst = _ref.closeMenuOnFirstItem,
      closeMenuOnFirstItem = _ref$closeMenuOnFirst === void 0 ? false : _ref$closeMenuOnFirst,
      _ref$resetSelectedIte = _ref.resetSelectedItemOnClose,
      resetSelectedItemOnClose = _ref$resetSelectedIte === void 0 ? false : _ref$resetSelectedIte;

  var _ref2 = (0, react_1.useState)(null),
      _ref3 = _slicedToArray(_ref2, 2),
      referenceElement = _ref3[0],
      setReferenceElement = _ref3[1];

  var _ref4 = (0, react_1.useState)(null),
      _ref5 = _slicedToArray(_ref4, 2),
      popperElement = _ref5[0],
      setPopperElement = _ref5[1];

  var modifiers = (0, react_1.useMemo)(function () {
    return [{
      name: 'sameWidth',
      enabled: true,
      fn: function fn(_ref6) {
        var state = _ref6.state;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
      },
      phase: 'beforeWrite',
      requires: ['computeStyles']
    }, {
      name: 'offset',
      options: {
        offset: offset
      }
    }];
  }, []);

  var _ref7 = (0, react_popper_1.usePopper)(referenceElement, popperElement, {
    placement: placement,
    modifiers: modifiers
  }),
      styles = _ref7.styles,
      attributes = _ref7.attributes,
      update = _ref7.update;

  var stateReducer = function stateReducer(state, actionAndChanges) {
    var type = actionAndChanges.type,
        changes = actionAndChanges.changes;

    switch (type) {
      case downshift_1.useSelect.stateChangeTypes.MenuKeyDownArrowDown:
        if (closeMenuOnLastItem && state.highlightedIndex === items.length - 1) {
          return _objectSpread({}, changes, {
            isOpen: false
          });
        }

        if (state.highlightedIndex === items.length - 1 && loopItemsOnKeyDown) {
          var newHighlightedIndex = 0; //if the first item is a header set the highlighted index to 1

          if (items[0].header) {
            newHighlightedIndex = 1;
          }

          return _objectSpread({}, changes, {
            isOpen: true,
            highlightedIndex: newHighlightedIndex
          });
        }

        return _objectSpread({}, changes, {
          isOpen: true
        });

      case downshift_1.useSelect.stateChangeTypes.MenuKeyDownArrowUp:
        if (closeMenuOnFirstItem && state.highlightedIndex === 0) {
          return _objectSpread({}, changes, {
            isOpen: false,
            highlightedIndex: -1
          });
        } // if the first item is a header and the user is on the first
        // item, set the highlighted index to the last item


        if (state.highlightedIndex === 1 && items[0].header && loopItemsOnKeyDown) {
          return _objectSpread({}, changes, {
            isOpen: true,
            highlightedIndex: items.length - 1
          });
        }

        if (state.highlightedIndex === 0 && loopItemsOnKeyDown) {
          return _objectSpread({}, changes, {
            isOpen: true,
            highlightedIndex: items.length - 1
          });
        }

        return _objectSpread({}, changes, {
          isOpen: true
        });

      case downshift_1.useSelect.stateChangeTypes.MenuKeyDownEnter:
      case downshift_1.useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        if (items[state.highlightedIndex] && items[state.highlightedIndex].menuItems) {
          return _objectSpread({}, changes, {
            highlightedIndex: state.highlightedIndex,
            isOpen: true
          });
        }

        if (type === downshift_1.useSelect.stateChangeTypes.MenuKeyDownEnter) {
          if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick();
        }

        if (resetSelectedItemOnClose) {
          return _objectSpread({}, changes, {
            isOpen: false,
            selectedItem: -1,
            highlightedIndex: -1
          });
        }

        return _objectSpread({}, changes);

      case downshift_1.useSelect.stateChangeTypes.ItemClick:
        if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick();

        if (resetSelectedItemOnClose) {
          return _objectSpread({}, changes, {
            isOpen: false,
            selectedItem: -1,
            highlightedIndex: -1
          });
        }

        return _objectSpread({}, changes);

      default:
        return changes;
      // otherwise business as usual.
    }
  };

  var _ref8 = (0, downshift_1.useSelect)({
    items: items,
    itemToString: itemToString,
    stateReducer: stateReducer
  }),
      isOpen = _ref8.isOpen,
      getToggleButtonProps = _ref8.getToggleButtonProps,
      getMenuProps = _ref8.getMenuProps,
      highlightedIndex = _ref8.highlightedIndex,
      selectedItem = _ref8.selectedItem,
      getItemProps = _ref8.getItemProps;

  (0, react_1.useEffect)(function () {
    update && update();
  }, [isOpen]);
  return {
    isOpen: isOpen,
    getToggleButtonProps: getToggleButtonProps,
    getMenuProps: getMenuProps,
    highlightedIndex: highlightedIndex,
    selectedItem: selectedItem,
    getItemProps: getItemProps,
    setReferenceElement: setReferenceElement,
    setPopperElement: setPopperElement,
    attributes: attributes,
    styles: styles,
    update: update
  };
};

exports["default"] = useDropdownMenu;